import { Fieldset } from "primereact/fieldset"
import styles from "../../../styles/Participant-GPRA.module.css"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { InputSwitch } from "primereact/inputswitch"
import FormError from "../Common/FormError"
import { useState } from "react"
import { useEffect } from "react"
const Conditional = ({
  question,
  setQuestion,
  validationErrors,
  removeError,
  questions,
  section,
  interviewType,
  disabled,
  groups,
  matrices,
}) => {
  const [sectionQuestions, setSectionQuestions] = useState([])
  const [tooltipText, setTooltipText] = useState("")
  const warningToolTipText =
    "Disable 'Required' to allow conditional display/require logic"

  useEffect(() => {
    setSectionQuestions(getSectionQuestions())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const conditionalTypes = () => {
    return [
      { label: "Is equal to", value: "==" },
      { label: "Is not equal to", value: "=/" },
      { label: "Is less than", value: "<" },
      { label: "Is greater than", value: ">" },
    ]
  }
  const setDropdownNumbers = (question) => {
    const group = groups.find((g) => g.id === question?.questionGroup?.id)
    const matrix = matrices.find((m) => m.id === group?.matrixGroup?.id)

    let legend = ""
    if (matrix) {
      legend += "[M" + matrix.number + "]"
    }
    if (group) {
      legend += "[G" + group.groupOrder + "]"
    }
    legend += `[Q${group ? question.groupOrder : question.number}]`
    return legend
  }
  const getSectionQuestions = () => {
    const additionalsFiltered = questions?.additionalQuestions
      ?.filter(
        (a) =>
          a.section === section &&
          a.form === interviewType &&
          a.title !== question.title
      )
      .map((a) => {
        return {
          label: `${setDropdownNumbers(a)} - ${a.title}`,
          value: a.title,
        }
      })
    const customizationsFiltered = questions?.customizations
      ?.filter(
        (a) =>
          a.section === section &&
          a.interviewType === interviewType &&
          a.label !== question.label
      )
      .map((c) => {
        return { label: `[Q${c.questionNumber}] - ${c.label}`, value: c.label }
      })
    const filtered = [...additionalsFiltered, ...customizationsFiltered]
    const selected = filtered.find(
      (f) => f.value === question.conditionalSource
    )
    if (selected) {
      setTooltipText(selected.label)
    }
    return filtered
  }
  return (
    <Fieldset legend="Conditional options">
      <div className={styles.formRow}>
        <label className={styles.mr1} htmlFor="binary">
          Source question
        </label>
        <Dropdown
          disabled={disabled}
          tooltip={disabled ? warningToolTipText : tooltipText}
          tooltipOptions={{ showOnDisabled: true }}
          value={question?.conditionalSource}
          onChange={(e) => {
            if (e.value) {
              setQuestion({
                ...question,
                conditionalSource: e.value,
              })
            } else {
              setQuestion({
                ...question,
                conditionalSource: "",
                conditionalType: "",
                conditionalValue: "",
                conditionalEnabled: false,
                conditionalRequired: false,
              })
            }
            setTooltipText(e?.originalEvent?.target?.firstChild?.data)
          }}
          className={styles.input5}
          options={sectionQuestions}
          optionLabel="label"
          optionValue="value"
          showClear
        />
      </div>
      <div className={styles.formRow} style={{ marginTop: "1rem" }}>
        <label className={styles.mr1} htmlFor="binary">
          Conditional type
        </label>
        <Dropdown
          tooltip={disabled && warningToolTipText}
          tooltipOptions={{ showOnDisabled: true }}
          disabled={!question.conditionalSource || disabled}
          showClear
          value={question?.conditionalType}
          onChange={(e) => {
            setQuestion({ ...question, conditionalType: e.value })
            removeError("conditionalType")
          }}
          options={conditionalTypes()}
          optionLabel="label"
          optionValue="value"
          className={
            validationErrors?.conditionalType
              ? styles.input5Error
              : styles.input5
          }
        />
        <FormError error={validationErrors?.conditionalType} errorType={2} />
      </div>
      <div className={styles.formRow} style={{ marginTop: "1rem" }}>
        <label className={styles.mr1} htmlFor="binary">
          Conditional value
        </label>
        <InputText
          tooltip={disabled && warningToolTipText}
          tooltipOptions={{ showOnDisabled: true }}
          disabled={!question.conditionalSource || disabled}
          value={question.conditionalValue}
          onChange={(e) => {
            setQuestion({ ...question, conditionalValue: e.target.value })
            removeError("conditionalValue")
          }}
          className={
            validationErrors?.conditionalValue
              ? styles.inputText5Error
              : styles.inputText5
          }
        />
        <FormError error={validationErrors?.conditionalValue} errorType={2} />
      </div>
      <div className={styles.formRow} style={{ marginTop: "1rem" }}>
        <label style={{ marginRight: "1.25rem" }} htmlFor="binary">
          Conditional display{" "}
        </label>
        <InputSwitch
          tooltip={disabled && warningToolTipText}
          tooltipOptions={{ showOnDisabled: true }}
          disabled={!question.conditionalSource || disabled}
          style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
          checked={question?.conditionalDisplay}
          onChange={(e) => {
            setQuestion({
              ...question,
              conditionalDisplay: e.value,
            })
          }}
        />
      </div>
      <div className={styles.formRow} style={{ marginTop: "1rem" }}>
        <label className={styles.mr1} htmlFor="binary">
          Conditional required
        </label>
        <InputSwitch
          tooltip={disabled && warningToolTipText}
          tooltipOptions={{ showOnDisabled: true }}
          disabled={!question.conditionalSource || disabled}
          style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
          checked={question?.conditionalRequired}
          onChange={(e) => {
            setQuestion({
              ...question,
              conditionalRequired: e.value,
            })
          }}
        />
      </div>
    </Fieldset>
  )
}
export default Conditional
